import { supabase } from "@/lib/supabase";

export async function fetchTemplates() {
    const { data, error } = await supabase
        .from("templates_ia_systeme")
        .select("id, type_dossier, prompt_systeme, created_at")
        .order("created_at", { ascending: false });
    if (error) throw error;
    const latest = {};
    for (const row of data ?? []) if (!latest[row.type_dossier]) latest[row.type_dossier] = row;
    return latest;
}

export async function saveTemplate(type_dossier, prompt_systeme) {
    const { data, error } = await supabase
        .from("templates_ia_systeme")
        .insert({ type_dossier, prompt_systeme })
        .select("id, type_dossier, prompt_systeme, created_at")
        .single();
    if (error) throw error;
    return data;
}
